import {
	RouteLocationNormalizedGeneric,
	RouteLocationRaw,
	RouteLocationResolved,
	RouteParamsGeneric,
	useRouter as useVueRouter,
} from "vue-router";
import { useAppTabs } from "~stores/useAppTabs.ts";

function useRouter() {
	const router = useVueRouter();
	const { addTab, sessionTabs } = useAppTabs();
	const previousUrl = computed(() => {
		return router.options.history.state.back as string;
	});

	const previousRoute = computed(() => {
		return router.resolve({ path: previousUrl.value });
	});

	const routeToTab = (destination: RouteLocationRaw) => {
		const route: RouteLocationResolved = router.resolve(destination);
		const matchedRoute = route.matched[0];

		if (matchedRoute?.components?.default == undefined) {
			console.error(`No component found for route: ${destination}`);
			return;
		}

		let props = matchedRoute.props.default;
		if (props instanceof Function) props = props(route as RouteLocationNormalizedGeneric);

		let title = route.meta?.tabTitle as string | ((params: RouteParamsGeneric) => string);
		if (title instanceof Function) title = title(route.params);

		addTab({
			title,
			fullPath: `${route.fullPath}${route.fullPath.includes("?") ? "&" : "?"}_t=${performance.now().toString()}`,
			props: typeof props === "object" ? props : undefined,
		});
	};

	return {
		...useVueRouter(),
		previousUrl,
		previousRoute,
		async push(route: RouteLocationRaw) {
			routeToTab(route);
		},
		async replace(route: RouteLocationRaw) {
			routeToTab(route);
		},
	};
}

export default useRouter;
